import React from 'react';
import Sidebar from '../Home/Sidebar/Sidebar';
import Footer from '../Shared/Footer/Footer';
import Menubar from '../Shared/Menubar/Menubar';
import ContactForm from './ContactForm';

const Contact = () => {
    return (
        <div className="h-100 contactBody">
            <div className="row">
                <div className="col-md-1">
                    <Sidebar/>
                </div>
                <div className="col-md-10">
                    <Menubar/>
                    <ContactForm/> 
                    <div className="mt-5">
                        <Footer/>
                    </div>                   
                   
                </div>
                <div className="col-md-1">

                </div>
            </div>
        </div>
    );
};

export default Contact;